module.exports = __webpack_public_path__ + "img/selected5-min.5cf74586.png";